import { lazy, Suspense } from 'react';
import type { RouteObject } from 'react-router';
import { RequerPermissao } from '@/app/RequerPermissao';
import { CarregandoTelaCheia } from '@/componentes/CarregandoTriplice';

/**
 * A primeira rota do painel carregada sob demanda (Implementacao §6; a iteração 1.12 do Usuários passa a
 * seguir este padrão).
 *
 * O chunk da página só contém **código**: o plano chega da API depois da autorização. Dividir aqui não é
 * só peso — é o que deixa a verificação do bundle (7.6) provar que nenhum texto do plano entrou no `.js`
 * público.
 *
 * `React.lazy` + `Suspense`, e não o `lazy` do objeto de rota, porque o `fallback` é nosso e aparece
 * também na navegação interna, não só no primeiro carregamento.
 *
 * 🚨 Segunda tranca: a que vale é o `@Permissao('plano.ver')` do backend.
 */
const PaginaPlanoEstrategico = lazy(() => import('./paginas/PaginaPlanoEstrategico'));

export const rotas: RouteObject[] = [
  {
    element: <RequerPermissao permissao="plano.ver" />,
    children: [
      {
        path: '/plano-estrategico',
        element: (
          <Suspense fallback={<CarregandoTelaCheia rotulo="Abrindo o plano estratégico…" />}>
            <PaginaPlanoEstrategico />
          </Suspense>
        ),
      },
    ],
  },
];
